<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} dịch vụ ẩm thực
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form ref="myForm" label-position="top" @submit.native.prevent
                :model="mData.tableRules.dataSearch.value" :rules="mData.tableRules.dataSearch.valid">
                <b-row>
                  <b-col md="4">
                    <el-form-item label="Tên" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['du_lieu_khai_bao.user_ten']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="4">
                    <el-form-item label="Mã số tài khoản" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['du_lieu_khai_bao.user_account']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button type="info" native-type="submit" v-ladda plain
                    @click="fn_tableSearch()">{{ aLang.c_search }}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{ aLang.c_showHideSearch }}</el-button>
            </div>
          </b-col>
        </b-row>
        <el-table :data="mData.tableRules.data" border @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange" max-height="440" style="width: 100%"
          :default-sort="{ prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1] }">
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="du_lieu_khai_bao.user_account" label="Mã số tài khoản"
            :sortable="mData.tableRules.allowSorting" align="center" width="150">
            <template slot-scope="scope">
              <el-link class="cell-child" target="_blank" @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false">{{ scope.row.du_lieu_khai_bao.user_account }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="du_lieu_khai_bao.user_ten" label="Tên" :sortable="mData.tableRules.allowSorting">
          </el-table-column>
          <el-table-column prop="du_lieu_khai_bao.user_dia_chi" label="Địa chỉ"
            :sortable="mData.tableRules.allowSorting">
            <template slot-scope="scope">
              <div class="text-left">
                {{ scope.row.du_lieu_khai_bao.user_dia_chi || '' }}
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button size="mini" @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail">
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update">
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete">
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">{{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick" :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit" :current-page="mData.tableRules.page" background
              layout="total, sizes, prev, pager, next, jumper" :total="mData.tableRules.total"
              :pager-count="5"></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from '../../../service/MethodService';
import DichVuDiemDenModel from '@/views/admin/DichVuDiemDen/DichVuDiemDenModel';
import DDATApi from '@/moduleApi/DDATApi';
import DonViCungCapApi from '@/moduleApi/DonViCungCapApi';
import { Filter } from 'mushroomjs';

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        moduleName: "DichVuAmThuc", //requied
        moduleNameDDAT: "DDAT",
        tableRules: MethodService.copyObject(DichVuDiemDenModel.tableRules),
        dataDefault: {},
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        ifHavePermission: false,
        ifHaveCreate: false
      }
    }
  },
  created() {
    this.fn_hashUrl();
    this.getDichVuAmThucList();
  },
  methods: {
    async getDichVuAmThucList() {
      let loaiFilter = Filter.or(Filter.eq("loai","restaurant"), Filter.eq("loai","tourist_area")).build();

      let dataFilter = {
        filters: (this.mData.tableRules.filters ? this.mData.tableRules.filters + "&" : "") + loaiFilter
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch
            }
          })
          .catch(() => { });
      }

      let res = await DonViCungCapApi.list(dataFilter);
      let resData = await this.fn_changeData(res.result);
      let diemDenAnToanIds = res.result.map(ids => ids.id);
      let arrDiemDenAnToanIds = MethodService.findListItemDifferent(diemDenAnToanIds);

      let resDiemDenAnToan = await DDATApi.list({
        filters: "id:in:" + arrDiemDenAnToanIds.join(",")
      });
      resData.map(item => {
        item.diem_den_an_toan = resDiemDenAnToan.result.find(x => x.id == item.id)
      })

      //end get name
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getDichVuAmThucList();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getDichVuAmThucList();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getDichVuAmThucList();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getDichVuAmThucList();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleNameDDAT + "-update",
          params: {
            id: row.id,
            type: "da-duyet"
          }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        }).then(() => {
          this.fn_delete(row.id);
        }).catch(() => { });
      }
    },

    async fn_delete(id) {
      await DonViCungCapApi.delete(id);
      this.getDichVuAmThucList();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
  }
}
</script>

<style scope>
.text-css {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.text-css p {
  margin: 0;
}
</style>
